import { useQuery } from "@tanstack/react-query"
import { ShieldAlert } from "lucide-react"

/**
 * Route-Riegel fuer ein einzelnes Recht (#27, 25.08.2026).
 *
 * 🔴 Auch das ist KEINE Sperre — die sitzt im Backend (`require_recht`). Diese
 * Huelle beantwortet nur die Frage, was jemand sieht, der die Adresse trotzdem
 * eintippt. Vorher war das: die Seite lud, feuerte ihre Abfragen und zeigte
 * ein halb gefuelltes Formular voller 403-Fehler. Wer sie aufrief, konnte
 * nicht unterscheiden, ob er nicht darf oder ob etwas kaputt ist.
 *
 * 🔑 Solange die Rechte nicht geladen sind, wird NICHT gesperrt — sonst blitzt
 * bei jedem Aufruf kurz eine Absage auf, obwohl alles in Ordnung ist.
 */
export function RechtRoute({ recht, children }: { recht: string; children: React.ReactNode }) {
  const konto = useQuery<{ rechte?: string[] }>({
    queryKey: ["konto"],
    queryFn: async () => {
      const r = await fetch("/api/v1/konto", { credentials: "include" })
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      return r.json()
    },
    staleTime: 1000 * 60 * 10,
  })

  const rechte = konto.data?.rechte
  if (konto.isLoading) {
    return <div style={{ padding: "20px 24px", fontSize: 13, color: "var(--text-muted)" }}>Lädt …</div>
  }
  if (rechte && !rechte.includes(recht)) {
    return (
      <div style={{ padding: "28px 24px", maxWidth: 460 }}>
        <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
          <ShieldAlert size={18} />
          <h1 style={{ fontSize: 17, fontWeight: 600 }}>Dafür fehlt dir die Berechtigung</h1>
        </div>
        {recht === "controlling" ? (
          // Namentlich freigegeben (core/rechte.py NAMENTLICH) — die Rolle allein reicht nicht.
          <p style={{ fontSize: 13, color: "var(--text-muted)" }}>
            Dieser Bereich ist nur für namentlich freigegebene Zugänge sichtbar.
          </p>
        ) : (
          <p style={{ fontSize: 13, color: "var(--text-muted)" }}>
            Dieser Bereich hängt am Recht „{recht}“. Wer Zugänge verwaltet, kann es
            deiner Rolle unter <strong>Zugänge → Rollen &amp; Rechte</strong> zuordnen.
          </p>
        )}
      </div>
    )
  }
  return <>{children}</>
}
